"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChartQuery = void 0;
function getChartQuery(measures, dateRange, filters, complexQueries, resultProcessor, timeDimension = 'Attribution.date', granularity = 'day') {
    const baseQuery = {
        measures,
        timeDimensions: [
            {
                dimension: timeDimension,
                granularity: granularity,
                dateRange,
            },
        ],
        order: {},
        filters,
        dimensions: [],
        limit: 10000,
    };
    return {
        queries: complexQueries && complexQueries.length > 0
            ? complexQueries.map(query => (Object.assign(Object.assign({}, baseQuery), query)))
            : [baseQuery],
        resultProcessor: resultProcessor ||
            (rows => ({
                lastRefreshTime: new Date(Math.max(...rows.flatMap(row => row
                    .serialize()
                    .loadResponse.results.map(result => new Date(result.lastRefreshTime).valueOf())))),
                seriesNames: () => [...rows[0].seriesNames()],
                chartPivot: () => [...rows[0].chartPivot()],
            })),
    };
}
exports.getChartQuery = getChartQuery;
//# sourceMappingURL=helper.js.map